/* U7 PDP — flavor-swap controller + gallery thumbs + format proxy + reviews
   show-more. Progressive enhancement; all nodes are pre-rendered in Liquid and
   toggled via `is-active`, so swaps never wait on the network.
   Event delegation on `document` survives Dawn's section re-renders. */
(function () {
  if (window.__u7PdpInit) return;
  window.__u7PdpInit = true;

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  /* Paint the selected flavor name into the big bar overlay. The native
     select's own text is transparent (so the OS dropdown popup renders at a
     readable size), so the overlay is what the shopper actually sees. */
  function syncFlavorValue(select) {
    var box = select.closest('.u7-flavor-box');
    if (!box) return;
    var value = box.querySelector('[data-u7-flavor-value]');
    if (!value) return;
    var opt = select.options[select.selectedIndex];
    value.textContent = ((opt && opt.text) || select.value || '').trim();
  }

  function eagerLoad(scope) {
    scope.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  }

  function playVideos(scope) {
    scope.querySelectorAll('video').forEach(function (video) {
      video.muted = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  function pauseVideos(scope) {
    scope.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });
  }

  /* Swap every per-flavor node on the page (gallery, buy-box description,
     supplement-facts can + panel) to the given flavor handle. */
  function activateFlavor(flavorHandle) {
    if (!flavorHandle) return;
    var groups = document.querySelectorAll('[data-u7-flavor]');
    if (!groups.length) return;
    groups.forEach(function (el) {
      var on = el.getAttribute('data-u7-flavor') === flavorHandle;
      el.classList.toggle('is-active', on);
      if (on) {
        eagerLoad(el);
        playVideos(el);
      } else {
        pauseVideos(el);
      }
    });
    /* flavor change re-points the whole rail — reset stage to the first thumb */
    document.querySelectorAll('[data-u7-gallery]').forEach(function (gallery) {
      setGalleryKind(gallery, null);
    });
  }

  /* Show the chosen media kind (can / canlid / tray / lifestyle...) inside the
     active flavor set of one gallery. kind=null resets to the first thumb. */
  function setGalleryKind(gallery, kind) {
    var rail = gallery.querySelector('.u7-gallery__thumbset.is-active');
    var set = gallery.querySelector('.u7-gallery__set.is-active');
    if (!set) return;
    var k = kind;
    if (!k && rail) {
      var firstThumb = rail.querySelector('[data-u7-thumb]');
      if (firstThumb) k = firstThumb.getAttribute('data-u7-thumb');
    }
    if (!k) return;
    set.querySelectorAll('[data-u7-main]').forEach(function (img) {
      img.classList.toggle('is-active', img.getAttribute('data-u7-main') === k);
    });
    if (rail) {
      rail.querySelectorAll('[data-u7-thumb]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-u7-thumb') === k);
      });
    }
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-u7-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-u7-gallery]');
      if (gallery) setGalleryKind(gallery, thumb.getAttribute('data-u7-thumb'));
      return;
    }

    /* Format toggle proxies the (hidden) Format/Size select inside Dawn's
       variant picker so price/availability flow through the normal pipeline. */
    var formatPill = event.target.closest('[data-u7-format-proxy]');
    if (formatPill) {
      var optionName = formatPill.getAttribute('data-option-name');
      var select = document.querySelector('.u7-pdp variant-selects select[name="' + optionName + '"]');
      if (select) {
        select.value = formatPill.getAttribute('data-value');
        select.dispatchEvent(new Event('change', { bubbles: true }));
        var wrap = formatPill.closest('.u7-format');
        if (wrap) {
          wrap.querySelectorAll('[data-u7-format-proxy]').forEach(function (pill) {
            pill.classList.toggle('is-selected', pill === formatPill);
          });
        }
      }
      return;
    }

    var more = event.target.closest('[data-u7-show-more]');
    if (more) {
      var section = more.closest('.u7-pdp-reviews');
      if (!section) return;
      var hidden = section.querySelectorAll('.u7-pdp-reviews__row.is-hidden');
      for (var i = 0; i < hidden.length && i < 4; i++) hidden[i].classList.remove('is-hidden');
      if (!section.querySelectorAll('.u7-pdp-reviews__row.is-hidden').length) {
        more.closest('.u7-pdp-reviews__more').hidden = true;
      }
    }
  });

  /* Flavor select (option 1) drives the whole page. */
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches || !select.matches('.u7-pdp variant-selects select')) return;
    var picker = select.closest('variant-selects');
    if (!picker || select !== picker.querySelector('select')) return; /* option 1 only */
    activateFlavor(handleize(select.value));
    syncFlavorValue(select);
  });

  function init() {
    /* Mock shows the reviews strip with first/last tiles edge-cropped — start
       the scroller centered. */
    document.querySelectorAll('.u7-pdp-reviews__track').forEach(function (track) {
      var delta = (track.scrollWidth - track.clientWidth) / 2;
      if (delta > 0) track.scrollLeft = delta;
    });
    document.querySelectorAll('[data-u7-flavor].is-active').forEach(function (el) {
      playVideos(el);
    });
    /* seed the bar overlay from the server-selected option (safety net; the
       value is also rendered in Liquid, so there is no flash) */
    document.querySelectorAll('.u7-flavor-box').forEach(function (box) {
      var select = box.querySelector('variant-selects select');
      if (select) syncFlavorValue(select);
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
